import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";
import { languageState } from "../../../states/languageState";

//初回言語設定
export const useInitialLanguageSetting = () => {
    const [t, i18n] = useTranslation();
    const [languageStatus , setLanguageStatus] = useRecoilState(languageState);

    const initializeLanguageSetting = () => {
        if (languageStatus.isFirstSetting === false) {
            const browserLanguage = navigator.language;
            console.log(`browserLanguage`,browserLanguage);
            if (browserLanguage === `ja` || browserLanguage === `ja-JP`) {
              i18n.changeLanguage(`ja`);
              setLanguageStatus({
                lang:`ja`,
                jaButtonColor:`white`,
                enButtonColor:`darkslategrey`,
                isFirstSetting:true,
              });
            }else{
              i18n.changeLanguage(`en`);
              setLanguageStatus({
                lang:`en`,
                jaButtonColor:`darkslategrey`,
                enButtonColor:`white`,
                isFirstSetting:true,
              });
            }
          }
    };

    return {
      initializeLanguageSetting : initializeLanguageSetting,
    }
}